import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineDescription } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";

const SupportingDocuments = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const TRANSLATION = t("SUBSCRIPTION_AMELLIS.PROOF", {
    returnObjects: true,
  });
  const BLOCK = get(TRANSLATION, "SUPPORTING_DOCUMENTS");

  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={BLOCK.TITLE} subtitle={BLOCK.SUBTITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={BLOCK.FORM.DOCUMENTS}
                icon={<MdOutlineDescription size={16} />}
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={TRANSLATION.ALLOWED_FILES_TYPE}
                multiple
                onUpload={(fileList) => {
                  setFieldValue("proof.supplementaryDocuments", fileList);
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      supplementaryDocuments: fileList,
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.supplementaryDocuments", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {TRANSLATION.ACTIONS.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SupportingDocuments;
